export default {
    API_URL: 'https://api.nasa.gov/planetary/apod',
    API_KEY: process.env.REACT_APP_API_KEY
}